import React from 'react';

import { FieldElementPropTypes } from '../propTypes';
import ValueField from '../../value-field';

const Value = ({ field: { id, label, mode, value, ...props }, ctx: { classes } }) => {
  return <ValueField label={label} value={value} mode={mode} classes={classes[id]} formField {...props} />;
};
Value.propTypes = FieldElementPropTypes;

export default Value;
